import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import InfoWidget, { config } from '../info-widget';

const InfoWidgetsSections = ({ data = {}, loading }) => {
  const { t } = useTranslation();
  const className = useMemo(() => Object.keys(data).length > 4 ? 'wrap' : 'no-wrap', [data]);
  const _entries = Object.entries(data).sort(([a], [b]) => {
    const _a = config[a] ? config[a]((s) => s) : { sort: 0 };
    const _b = config[b] ? config[b]((s) => s) : { sort: 0 };
    return _a.sort - _b.sort;
  })

  return (
    <section style={{ minHeight: 89.4 }} id="5c">
      {_entries.map(([k, v]) => (
        <InfoWidget
          className={className}
          confignKey={k}
          key={`${v}-${k}-info-sections`}
          loading={loading}
          value={v}
          t={t}
        />
      ))}
    </section>
  )
};

export default InfoWidgetsSections;
